import { render, staticRenderFns } from "./CusPaymentsTableAllUser.vue?vue&type=template&id=70ebaaea"
import script from "./CusPaymentsTableAllUser.vue?vue&type=script&lang=js"
export * from "./CusPaymentsTableAllUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports